import { DEFAULT_MAX_MEDIA_HEIGHT } from './../admin/MediaHeightField';
import { SubjectImagePreferences } from './../../services/queue.model';

interface ImageFilterStyles {
  filter?: string;
  transform?: string;
  maxHeight?: string;
}

export const generateImageFilters = (subjectImagePreferences?: SubjectImagePreferences): ImageFilterStyles => {
  const grayscaleFilterPercent = subjectImagePreferences?.grayScalePercent || 100;
  const rotate180 = 'rotate(180deg)';
  const flip = 'scaleX(-1)';
  const returnStyles: ImageFilterStyles = {};
  let filters = '';
  let transformations = '';
  if (subjectImagePreferences) {
    if (subjectImagePreferences.isDefaultBlur) {
      filters += `blur(${subjectImagePreferences.blurStrengthPixels}px) `;
    }
    if (subjectImagePreferences.isDefaultGrayscale) {
      filters += `grayscale(${grayscaleFilterPercent}%)`;
    }
    if (subjectImagePreferences.isDefaultFlipped) {
      transformations += rotate180;
    }
    if (subjectImagePreferences.isDefaultMirrored) {
      transformations += flip;
    }

    if (filters) {
      returnStyles.filter = filters;
    }
    if (transformations) {
      returnStyles.transform = transformations;
    }

    returnStyles.maxHeight = `${subjectImagePreferences.maxHeight || DEFAULT_MAX_MEDIA_HEIGHT}px`;
  }

  return returnStyles;
};
